// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tempLeftTabBtn{width:20px;height:20px;border-radius:5px;background:#ccc;filter:drop-shadow(0 1px 2px #cccccc);display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
